import React, { useState, useEffect } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import NoDataFound from "../../../partials/NoDataFound"
import { trans } from "../../../../_providers/Translation"
import ServicingOptions from "./ServicingOptions"
import moment from "moment"
import Pagination from "@/components/Pagination"

export default function ServicingList({
  handleEdit,
  handleDelete,
  refresh,
}) {
  const [data, setData] = useState({
    loading: true,
    data: [],
    page: 1,
    pages: 0,
    update: false,
  })

  useEffect(() => {
    loadServicing()
  }, [refresh, data.update])

  const loadServicing = () => {
    setData((prev) => ({
      ...prev,
      loading: true,
    }))

    let url = "contractors/appliance-servicing?page=" + data.page

    Api.get(url)
      .then((res) => {
        setData((prev) => ({
          ...prev,
          loading: false,
          data: res.data.items,
          pages: res.data.pages,
        }))
      })
      .catch(() => {
        setData((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  const handlePage = (page) => {
    setData((prev) => ({
      ...prev,
      page: page.selected + 1,
      update: new Date().getTime(),
    }))
  }

  return (
    <div className="pannel">
      {data.loading ? (
        <Skeleton height={45} count={10} />
      ) : data.data.length === 0 ? (
        <NoDataFound message={trans("messages.noAddedSubscriptions")} />
      ) : (
        <>
          <div className="table-scroller">
            <table>
              <thead>
                <tr>
                  <th>{trans("tables.name")}</th>
                  <th>{trans('tables.dateOfFirstServicing')}</th>
                  <th>{trans('tables.servicingActionsCount')}</th>
                  <th className="options">{trans("tables.options")}</th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((sub) => {
                  return (
                    <tr key={"sub-" + sub.id}>
                      <td>{sub.name || "-"}</td>
                      <td>
                        {sub.date_of_first_servicing
                          ? moment(
                              sub.date_of_first_servicing,
                              "YYYY-MM-DD",
                            ).format("DD MMM YYYY")
                          : "-"}
                      </td>
                      <td>{sub.servicing_actions.length || 0}</td>
                      <td>
                        <ServicingOptions
                          id={sub.id}
                          data={sub}
                          handleEdit={handleEdit}
                          handleDelete={handleDelete}
                        />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            pages={data.pages}
            page={data.page}
            handlePage={handlePage}
          />
        </>
      )}
    </div>
  )
}
